import { Reducer} from "redux";

export enum LoadingActionType {
  start = "startLoading",
  finish = "finishLoading",
}

export interface LoadingState {
  loadingCount: number;
}

interface LoadingAction {
  type: LoadingActionType;
  [key: string]: unknown;
}

export const startLoading: LoadingAction = {type: LoadingActionType.start};
export const finishLoading: LoadingAction = {type: LoadingActionType.finish};

const loadingCounter = 1;
const initialState: LoadingState = { loadingCount: 0 };

export const reducer: Reducer<LoadingState> = (
  state = initialState,
  incomingAction
) => {
  const action = incomingAction as unknown as LoadingAction;
  switch (action.type) {
    case LoadingActionType.finish:
      return {
        ...state,
        loadingCount: state.loadingCount - loadingCounter,
      };
    case LoadingActionType.start:
      return {
        ...state,
        loadingCount: state.loadingCount + loadingCounter,
      };
    default:
      return state;
  }
};
